import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { BuildYourAppListing } from '~/models/administration/buildYourApp';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class BuildYourAppsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getBuildYourApp(id: number) {
        return this.http.get<BuildYourAppListing>(this._url(`/${id}`));
    }

    getBuildYourAppListing() {
        return this.http.get<BuildYourAppListing[]>(this._url());
    }

    getBuildYourApps(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<BuildYourAppListing[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
    }

    createBuildYourApp(model: any) {
        return this.client.post<string>(this._url(), model);
    }

    updateBuildYourApp(id: number, model: any) {
        return this.client.put(this._url(`/${id}`), model);
    }

    deleteBuildYourApp(id: number) {
        return this.client.delete(this._url(`/${id}`));
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/BuildYourApps${v}`);
    }
    
    getTransactionListingByMobileAppGroupId(mobileAppGroupId: number) {
        return this.http.get<any[]>(this._url(`/transactionspergroup/${mobileAppGroupId}`));
    }

    getFieldsListingByTransactionId(transactionId: number) {
        return this.http.get<any[]>(this._url(`/fieldspertransaction/${transactionId}`));
    }
}
